import DOMPurify from 'dompurify'

import {
  type ColumnConfigurations,
  type FormCustomTemplate,
  type TableColumnType,
  COLUMN_DEFINITIONS,
  TableColumnType as TableColumnTypeEnum,
  createNameCell,
} from './definitions'

type ListItemDefinition = (item: FormCustomTemplate) => {
  title: string
  description: string[]
}

type ListField = {
  label: string
  render: (item: FormCustomTemplate) => {
    type: 'text' | 'dotTag' | 'status' | 'person' | 'tag'
    value: unknown
  }
}

export type ListFields = {
  itemDefinition: ListItemDefinition
  fields: ListField[]
}

export const createListProperties = (
  columns: TableColumnType[],
  configurations?: ColumnConfigurations
): ListFields => {
  const itemDefinition = (item: FormCustomTemplate) => {
    const nameCell = createNameCell(item)
    const title = typeof nameCell.value.text === 'string' ? nameCell.value.text : ''
    const description: string[] = item.description
      ? [DOMPurify.sanitize(item.description, { ALLOWED_TAGS: [] })]
      : []
    return { title, description }
  }

  const fields: ListField[] = columns
    .filter((col) => col !== TableColumnTypeEnum.Name && col in COLUMN_DEFINITIONS)
    .map((col) => {
      const def = COLUMN_DEFINITIONS[col]
      return {
        label: def.label(),
        render: def.render(configurations),
      }
    })

  return { itemDefinition, fields }
}
